import { Record } from 'immutable';
import type { RecordFactory, RecordOf } from 'immutable';

import type { FI_AGGREGATOR } from 'data/institutions/types';

type AccountChipDataProps = {
  aggregation: ?FI_AGGREGATOR,

  id: string,
  name: string,

  isManual: boolean,

  logo: ?string,
  logoUrl: ?string,
  primaryColor: ?string,
}
export type AccountChipData = RecordOf<AccountChipDataProps>;
export const mkAccountChipData: RecordFactory<AccountChipDataProps> =
  new Record({
    aggregator: null,

    id: "0",
    name: "",

    isManual: false,

    logo: null,
    logoUrl: null,
    primaryColor: null,
  });

